
import BaseMixin from '@/views/mixin.vue'
import { mapState, mapGetters } from 'vuex'

import { HttpVsStockList } from '@/service/boss/allot';

import compSearch from './search';
import compDetail from './detail';

import {Dropdown, Icon, Button } from 'view-design'


export default {
    mixins: [BaseMixin],
    components: {
        compSearch,
        compDetail,
    },
    data() {
        return {
            data: [],
            checkedId: [],
        };
    },
    methods: {
        httpList: HttpVsStockList,
        handleOperates(id, type, row) {
            this.operate = {};
            switch (type) {
				case 'query':
					this.operate = {
						...id,
						title: this.$t('global.common.query',{defaultValue:'查看'}),
						component: 'compDetail',
						show: true,
						width: 920,
						footer: false,
					}; break;
			}
        },
        
    },
    computed: {
		...mapGetters('diction',['getNewDifferentAllProductList','getNewWarehouseIdList']),
		columns() {
			return [{
				title: this.$t('global.common.operate',{defaultValue:'操作'}),
				width: 80,
				render: (h, { row }) => {
					const id = row.stockVirtualGroupRuleItemId, erpSku = row.erpSku , stockVirtualGroupRuleName = row.stockWarehouseName;
					return <Button size='small' type='primary' onClick={this.handleOperates.bind(this, { id, erpSku, stockVirtualGroupRuleName }, 'query')}>{this.$t('global.common.query',{defaultValue:'查看'})}</Button>
				}
			},
			{
				title: this.$t('global.common.project',{defaultValue:'项目'}),
				width: 160,
				key: 'lineId',
				render: (h, { row }) => {
					const id = row.lineId,
						result = this.getNewDifferentAllProductList.filter((item) => {
							// console.log(item)
							return item.value == id;
						})[0] || {};
					return <span>{result.label}</span>
				}
			},
			{
				title: 'ERPSKU',
				key: 'erpSku',
				sortable: true,
				width: 160,
			},
			{
				title: this.$t('erp.virtualstore.entitywarehouse',{defaultValue:'实体仓'}),
				key: 'orgWarehouseId',
				sortable: true,
				render: (h, { row }) => {
					const id = row.orgWarehouseId,
						result = this.getNewWarehouseIdList.filter((item) => {
							return item.value == id;
						})[0] || {};
					return <span>{result.label}</span>
				}
			},
			{
				title: this.$t('fbb.warehouse.virtual_warehouse',{defaultValue:'虚拟仓'}),
				key:"stockWarehouseName"
				// render: (h, { row }) => {
				// 	const data=row.stockVirtualGroupRuleItem || {};
				// 	return <span>{data.warehouseTitle}-{data.stockVirtualGroupRuleName}</span>
				// }
			},
			{
				title: this.$t('fbb.accountmanage.amount',{defaultValue:'数量'}),
				key: 'quantity',
				sortable: true,
			},
			{
				title: this.$t('fbb.headlogistics.chushihua',{defaultValue:'初始化'})+this.$t('global.datepicker.time',{defaultValue:'时间'}),
				key: 'initTime',
				sortable: true,
			},

			];
		},
	},
};




